export default {
  id: "weblinkSales15",
  name: "",
  description: "",
  report: {
    name: "Weblink Sales (15)",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataSet: "Sale",
      dataType: "time_series",
      dimensions: [],
      measures: ["Sale.total_revenue"],
      sort: {
        direction: null,
        by: null,
      },
      timeDimension: "Sale.sale_time",
      timeGranularity: "day",
      filters: [
        {
          member: "Sale.weblink_group",
          operator: "equals",
          values: ["15"],
        },
      ],
      compare: true,
      limit: "999",
      rowTotals: false,
      points: false,
      colorTheme: "default",
    },
  },
};
